import React from "react"
import { css, cx } from "emotion"

const Select = ({ className, ...rest }) => {
  return (
    <div
      className={cx(
        css`
          position: relative;
          /* arrows */
          &::before,
          &::after {
            position: absolute;
            right: 5px;
            user-select: none;
            pointer-events: none;
            font-size: 0.5em;
          }
          /* up arrow */
          &::before {
            content: "\\25b2";
            bottom: 50%;
          }
          /* down arrow */
          &::after {
            content: "\\25bc";
            top: 50%;
          }
          /* select */
          select {
            display: block;
            width: 100%;
            font-size: 1em;
            padding: 1em 1.5em;
            appearance: none;
          }
        `,
        className
      )}>
      <select {...rest} />
    </div>
  )
}

export default Select



// WEBPACK FOOTER //
// ./src/components/Select.js